export const userAction = {
  setUserList: (state, action) => {
    state.userList = action.payload;
  },
};
